import React, { useEffect, useRef, useState } from "react";
import hljs from "highlight.js";
import ReactQuill from "react-quill-new";
import { Link } from "react-router-dom";
import { createEmailTemplate, createInsuranceChargesApi, createPackageApi, getInsuranceChargeApi, getPackageSizeApi } from "../../apiHelper/authService";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { clearSelectedPackage } from "../../redux/authModalSlice";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
const Insurance = () => {
    const navigate = useNavigate()
    const [imagePreview, setImagePreview] = useState(null);
    const { selectedPackage } = useSelector((state) => state.authModal);
    const { user } = useSelector((state) => state.authModal);
    const fromCountry = user?.from;
    const toCountry = user?.to;

    // const handleFileChange = (e) => {
    //     if (e.target.files && e.target.files.length > 0) {
    //         const src = URL.createObjectURL(e.target.files[0]);
    //         setImagePreview(src);
    //     }
    // };

    // const handleRemoveImage = () => {
    //     setImagePreview(null);
    // };
    const quillRef = useRef(null);
    const [value, setValue] = useState(``);
    // eslint-disable-next-line no-unused-vars
    const [isHighlightReady, setIsHighlightReady] = useState(false);
    const dispatch = useDispatch()

    useEffect(() => {
        // Load highlight.js configuration and signal when ready
        hljs?.configure({
            languages: [
                "javascript",
                "ruby",
                "python",
                "java",
                "csharp",
                "cpp",
                "go",
                "php",
                "swift",
            ],
        });
    }, []);

    // eslint-disable-next-line no-unused-vars
    const handleSave = () => {
        const editorContent = quillRef.current.getEditor().root.innerHTML;
        console.log("Editor content:", editorContent);
    };

    // Quill editor modules with syntax highlighting (only load if highlight.js is ready)
    const modules = isHighlightReady
        ? {
            syntax: {
                highlight: (text) => hljs?.highlightAuto(text).value, // Enable highlight.js in Quill
            },
            toolbar: {
                container: "#toolbar-container", // Custom toolbar container
            },
        }
        : {
            toolbar: {
                container: "#toolbar-container", // Custom toolbar container
            },
        };

    const formats = [
        "font",
        "size",
        "bold",
        "italic",
        "underline",
        "strike",
        "color",
        "background",
        "script",
        "header",
        "blockquote",
        "code-block",
        "list",
        "indent",
        "direction",
        "align",
        "link",
        "image",
        "video",
        "formula",
    ];


    const [percentAmount, setPercentAmount] = useState('');
    const [gstPercent, setGstPercent] = useState('');
    const [uptoVal, setUptoVal] = useState('');

    const [loading, setLoading] = useState(false)

    const [selectedUnit, setSelectedUnit] = useState("Inch");


    const [subject, setSubject] = useState('');






    // const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');

    const [packageId, setPackageId] = useState(''); // can be generated or user-input
    const [mailImage, setMailImage] = useState(null);
    //   const [imagePreview, setImagePreview] = useState(null);

    //   const quillRef = useRef();
    const [imageName, setImageName] = useState('');

    const [ShipmentCharges, setShipmentCharges] = useState([]);



    const getInsuranceCharges = async () => {
        setLoading(true);



        // const toastId = toast.loading("Fetching Email Templates...");

        try {
            const data = await getInsuranceChargeApi();
            console.log(data)
            // setShipmentCharges(data?.shipmentCharges || []);
            setPercentAmount(data?.percentage_amount)
            setGstPercent(data?.gst_percentage)
            setUptoVal(data?.upto_value)



            // setCategories(data);
            // setPackageData(data)
            // toast.success("Email Templates fetched successfully!", { id: toastId });
        } catch (err) {
            console.error("Fetch Error:", err);

            // toast.error(
            //     err?.message || "Something went wrong while fetching email templates.",
            //     { id: toastId }
            // );
        } finally {
            setLoading(false);
        }
    };


    const createInsurance = async (e) => {
        e.preventDefault();
        setLoading(true);



        // const toastId = toast.loading("Saving");

        try {
            const data = await createInsuranceChargesApi({gst_percentage:Number(gstPercent), percentage_amount:Number(percentAmount) , upto_value: Number(uptoVal)});
            console.log(data)
            // setShipmentCharges(data?.shipmentCharges || []);
        


            // setCategories(data);
            // setPackageData(data)
            // toast.success(" successfully!", { id: toastId });
        } catch (err) {
            console.error("Fetch Error:", err);

            toast.error(
                err || "Something went wrong .",
          
            );
        } finally {
            setLoading(false);
        }
    };

    // console.log(ShipmentCharges)


    useEffect(() => {

        getInsuranceCharges()


    }, [])

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type.startsWith('image/')) {
            setMailImage(file);

            setImagePreview(URL.createObjectURL(file));
            setImageName(file.name);
        } else {
            alert('Please upload a valid image file');
        }
    };

    const handleRemoveImage = () => {
        setMailImage(null);

        setImagePreview(null);
        setImageName('');
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();




    //     if (!imagePreview) {
    //         toast.error("Image is required");
    //         return;
    //     }




    //     const formData = new FormData();
    //     formData.append('size_name', sizeName);
    //     formData.append('size_length', sizeLength);
    //     formData.append('size_width', sizeWidth);
    //     formData.append('size_height', sizeHeight);
    //     formData.append('size_weight', sizeWeight);
    //     formData.append('discount', discount);
    //     formData.append('inch', selectedUnit === "Inch" ? true : false);



    //     formData.append('from', fromCountry);
    //     formData.append('to', toCountry);
    //     formData.append('id', packageId);


    //     if (mailImage) {
    //         formData.append('icon_url', mailImage);
    //     }

    //     try {
    //         const res = await createPackageApi(formData);
    //         console.log('Success:', res);
    //         navigate("/package-sizes")


    //     } catch (err) {

    //         console.error('Error:', err);
    //     }


    // };

    //Insert var|

    // const insertVariable = (e) => {
    //     const variable = e.target.value;

    //     if (!variable || !quillRef.current) return;

    //     const editor = quillRef.current.getEditor();
    //     const cursorPosition = editor.getSelection()?.index || 0;
    //     editor.insertText(cursorPosition, `{${variable}}`);
    //     editor.setSelection(cursorPosition + variable.length + 2);
    //     e.target.value = '';
    // };

    console.log("Package", selectedPackage)



    const handleNumericInput = (e, setter) => {
        const value = e.target.value;

        if (/^\d*\.?\d*$/.test(value)) {
            setter(value);
        }
    };




    return (
        <div className='row gy-4'>
            <div className='col-lg-12'>
                <div className='card mt-24'>
                    <div className='card-header border-bottom'>
                        <h6 className='text-xl mb-0'>Insurance Charges</h6>
                    </div>
                    <div className='card-body p-24'>
                        <form className='d-flex flex-column gap-20' onSubmit={createInsurance}>

                            <div className="row">
                                <div className="col-12 col-md-4 mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='percentAmount'>
                                        Percent Amount
                                    </label>
                                    <input
                                        type='text'
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        id='percentAmount'
                                        placeholder='Enter Percent Amount'
                                        value={percentAmount}
                                        // onChange={(e) => setPercentAmount(e.target.value)}
                                             onChange={(e) => handleNumericInput(e, setPercentAmount)}

                                    />
                                </div>

                                <div className="col-12 col-md-4 mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='gstPercent'>
                                        GST Percent
                                    </label>
                                    <input
                                        type='text'
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        id='gstPercent'
                                        placeholder='Enter GST Percent'
                                        value={gstPercent}
                                        // onChange={(e) => setGstPercent(e.target.value)}
                                             onChange={(e) => handleNumericInput(e, setGstPercent)}

                                    />
                                </div>

                                <div className="col-12 col-md-4 mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='uptoVal'>
                                        Upto Value ($)
                                    </label>
                                    <input
                                        type='text'
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        id='uptoVal'
                                        placeholder='Enter  Upto Value'
                                        value={uptoVal}
                                        // onChange={(e) => setUptoVal(e.target.value)}
                                             onChange={(e) => handleNumericInput(e, setUptoVal)}

                                    />
                                </div>
                            </div>














                            <div className="w-100 text-center">
                                <button type="submit" className="btn btn-primary-600 radius-8">
                                    Save
                                </button>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
            {/* Sidebar Start */}

        </div>
    );
};

export default Insurance;
